<div class="dialog-container">
  <div class="dialog-header">
    <h2 mat-dialog-title class="text-gradient">Pagamento PIX</h2>
    <p>{{ data.event.title }}</p>
    <button mat-icon-button class="close-btn" (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">

    <!-- Loading -->
    <div *ngIf="loading" class="loading-container">
      <mat-spinner diameter="48"></mat-spinner>
      <p>Gerando cobranca PIX...</p>
    </div>

    <!-- Error -->
    <div *ngIf="error && !loading" class="error-container">
      <mat-icon class="error-icon">error_outline</mat-icon>
      <p>{{ error }}</p>
      <button mat-raised-button color="accent" (click)="retry()" class="retry-btn">
        TENTAR NOVAMENTE
      </button>
    </div>

    <!-- Payment Confirmed -->
    <div *ngIf="paymentConfirmed && !loading" class="success-container">
      <mat-icon class="success-icon">check_circle</mat-icon>
      <h3>Pagamento Confirmado!</h3>
      <p>Sua inscricao foi confirmada com sucesso. Prepare-se para a aventura!</p>
    </div>

    <!-- PIX QR Code -->
    <div *ngIf="payment && !loading && !error && !paymentConfirmed" class="pix-container">

      <div class="timer-bar">
        <mat-icon>timer</mat-icon>
        <span>Expira em: <strong>{{ countdown }}</strong></span>
      </div>

      <div class="qr-code-section">
        <img *ngIf="payment.pixQrCode"
             [src]="'data:image/png;base64,' + payment.pixQrCode"
             alt="QR Code PIX"
             class="qr-code-image">
      </div>

      <mat-divider class="section-divider"></mat-divider>

      <div class="copy-paste-section">
        <p class="copy-label">Ou copie o codigo PIX:</p>
        <div class="copy-container">
          <input type="text" [value]="payment.pixCopyPaste" readonly class="pix-code-input">
          <button mat-raised-button color="accent" (click)="copyPixCode()" class="copy-btn">
            <mat-icon>content_copy</mat-icon>
            COPIAR
          </button>
        </div>
      </div>

      <mat-divider class="section-divider"></mat-divider>

      <div class="info-section">
        <ng-container *ngIf="!data.event.absorbServiceFee">
          <div class="info-row">
            <span class="info-label">Inscrição:</span>
            <span class="info-value">{{ payment.organizerAmount | currency:'BRL' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">Taxa da plataforma:</span>
            <span class="info-value">{{ payment.platformFee | currency:'BRL' }}</span>
          </div>
        </ng-container>
        <div class="info-row total-row">
          <span class="info-label">Total:</span>
          <span class="info-value">{{ payment.amount | currency:'BRL' }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">Status:</span>
          <span class="info-value status-waiting">
            <mat-icon class="status-icon">hourglass_top</mat-icon>
            Aguardando pagamento
          </span>
        </div>
      </div>

      <div class="instructions">
        <p><strong>Como pagar:</strong></p>
        <ol>
          <li>Abra o app do seu banco</li>
          <li>Escolha pagar via PIX</li>
          <li>Escaneie o QR Code ou cole o codigo</li>
          <li>Confirme o pagamento</li>
        </ol>
        <p class="auto-confirm">A confirmacao e automatica apos o pagamento.</p>
      </div>
    </div>

  </mat-dialog-content>
</div>
